export function adultsInRoom (room) {
  return passengersInRoomOfType(room, 'adult')
}

export function childrenInRoom (room) {
  return passengersInRoomOfType(room, 'child')
}

export function numberOfAdultsInRoom (room) {
  return adultsInRoom(room).length
}

export function numberOfChildrenInRoom (room) {
  return childrenInRoom(room).length
}

export function passengersInRoomOfType (room, type) {
  return room.passengers.filter(p => p.type == type)
}
